import React from 'react';

import { IStackedHeroFields } from '../../../types/contentful';

import RichText from '../RichText';
import { renderUnoptimizedImage } from '../../utils/contentful';

export function StackedHero({
  copy,
  headingText,
  image,
  desktopImage
}: IStackedHeroFields) {
  return (
    <section
      className="mt-3 box-border flex w-full scroll-mt-16 justify-center [&>*]:max-w-screen-max [&>*]:px-3 tablet:[&>*]:px-12"
      data-blockid="stacked-hero"
      data-testid="stacked-hero"
      data-e2e="hero"
    >
      <div className="box-border flex-[1_0_100%]">
        <div className="box-border">
          <div className="-mx-3 flex flex-wrap justify-center desktop:-mx-4 [&>*:first-child]:pt-0 desktop:[&>*:first-child]:pt-0 [&>*]:p-3 desktop:[&>*]:p-4">
            <div className="w-full shrink-0 grow-0">
              <div className="relative z-0 box-border w-full overflow-hidden">
                <div
                  className="hidden tablet:block"
                  data-testid="hero-desktop-image"
                >
                  {renderUnoptimizedImage(
                    desktopImage || image,
                    'h-full w-full rounded-[104px] object-cover'
                  )}
                </div>
                <div
                  className="block tablet:hidden"
                  data-testid="hero-mobile-image"
                >
                  {renderUnoptimizedImage(
                    image,
                    'h-full w-full rounded-[64px] object-cover'
                  )}
                </div>
              </div>
            </div>

            <div className="w-[75%] shrink-0 grow-0 pb-1 tablet:w-1/2">
              <h1 className="w-full text-center text-[34px] font-medium leading-[36px] tablet:text-left tablet:text-[50px] tablet:leading-[55px]">
                {headingText}
              </h1>
            </div>
            {copy && (
              <div className="w-[83.333%] shrink-0 grow-0 tablet:w-1/3">
                <div className="text-center tablet:text-left [&:last-child>a]:mt-[17px]">
                  <RichText data={copy} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
